<script lang="ts">
  import { getStores } from "app/stores";
  import { isUserAuthed } from "app/stores/auth";
  import { isPrivateCommunity } from "app/stores/community";
  import { isCommunityMember } from "app/stores/permissions";
  import { search } from "app/stores/search";
  import { devToolbar } from "app/stores/devToolbar";
  import { shortcuts, shortcutsList } from "app/stores/shortcuts";
  import { thread } from "app/stores/thread";
  import { notEmpty } from "app/utils/ts-helpers";

  const { user, userPreferences } = getStores();

  $: userCanViewToolbar = !__IS_PROD__ && $user.isAuthed && $user.email?.endsWith("@outverse.com");

  $: unrestrictedAccess =
    ($isPrivateCommunity !== undefined && !$isPrivateCommunity) || $isCommunityMember;

  // default shortcuts actions
  $: actions = [
    unrestrictedAccess && $isUserAuthed
      ? {
          id: "createThread",
          name: "Create a thread",
          shortcut: "Shift+N",
          keywords: "create thread",
          section: "Actions",
          perform: () => {
            thread.openThreadModal();
            $search = false;
          },
        }
      : undefined,
    unrestrictedAccess
      ? {
          id: "collapseExpandSidebar",
          name: "Collapse/Expand sidebar",
          shortcut: "Shift+S",
          keywords: "collapse expand sidebar",
          section: "Preferences",
          perform: userPreferences.toggleLeftPanelExpansion,
        }
      : undefined,
    userCanViewToolbar
      ? {
          id: "toggleDevToolbar",
          name: "Toggle dev toolbar",
          shortcut: "`",
          keywords: "toggle dev toolbar",
          section: "Developer",
          perform: () => {
            $devToolbar = !$devToolbar;
          },
        }
      : undefined,
  ].filter(notEmpty);

  // controller is an array of keys that are currently pressed
  let controller: string[] = [];

  // when a key is released, check if it matches any of the shortcuts
  function keyUp(e: KeyboardEvent) {
    $shortcutsList.forEach((action) => {
      const keys = action.shortcut.split("+");
      if (keys.every((key) => [...new Set(controller)].includes(key.toLowerCase()))) {
        action.perform();
      }
    });

    // remove the key that was released
    controller = controller.filter((key) => key !== e.key.toLowerCase());
  }

  // when a key is pressed, add it to the controller
  function keyDown(e: KeyboardEvent) {
    const { tagName, isContentEditable } = e.target as HTMLElement;
    const exemptTags = ["INPUT", "TEXTAREA"];
    if (!exemptTags.includes(tagName) && !isContentEditable) {
      controller.push(e.key.toLowerCase());
    }
  }

  // update the shortcuts to the store when the actions change
  $: shortcuts.addShortcuts(actions);
</script>

<svelte:window on:keydown={keyDown} on:keyup={keyUp} />
